import React from 'react';
import { useTheme } from 'styled-components';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function CheckmarkGraphic() {
  const theme = useTheme();

  return theme.name === 'lightTheme' ? (
    <svg
      width="190"
      height="156"
      viewBox="0 0 190 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152.252 117.359C151.282 134.266 132.39 141.92 117.91 145.391C104.465 148.605 90.3022 148.774 76.7579 146.049C60.0587 142.945 39.284 131.292 39.4138 114.255L38.5048 122.031C38.352 138.276 58.3284 149.512 74.5311 152.979C86.9066 155.815 99.8664 156.102 112.372 153.948C126.424 151.426 143.318 145.027 150.438 131.778C151.641 129.429 152.451 126.872 152.71 124.239C152.878 123.505 151.794 116.371 151.817 115.2C151.817 115.414 152.264 117.144 152.256 117.355L152.252 117.359Z"
        fill="#B7C0EB"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          opacity="0.02"
          d="M31.4377 121.976C30.3683 133.541 46.579 144.621 67.6574 146.57C88.7357 148.519 106.703 140.6 107.773 129.035C108.842 117.47 92.6297 106.407 71.5513 104.458C50.4729 102.509 32.507 110.411 31.4377 121.976Z"
          fill="#FDFDFF"
        />
        <path
          opacity="0.05"
          d="M32.0283 122.071C30.9697 133.519 47.0915 144.627 68.0643 146.567C89.04 148.506 106.922 140.545 107.981 129.097C109.039 117.649 92.9144 106.574 71.9416 104.635C50.9687 102.696 33.0868 110.623 32.0283 122.071Z"
          fill="#FBFCFE"
        />
        <path
          opacity="0.07"
          d="M32.6331 122.165C31.5851 133.498 47.6184 144.631 68.4886 146.56C89.3588 148.49 107.161 140.489 108.209 129.153C109.258 117.816 93.2194 106.738 72.3495 104.806C51.4793 102.876 33.6813 110.828 32.6333 122.162L32.6331 122.165Z"
          fill="#FAFAFE"
        />
        <path
          opacity="0.1"
          d="M33.2268 122.26C32.1894 133.48 48.134 144.638 68.8987 146.558C89.6634 148.478 107.383 140.435 108.421 129.216C109.458 117.997 93.5074 106.906 72.7427 104.986C51.978 103.066 34.2643 111.041 33.2266 122.263L33.2268 122.26Z"
          fill="#F8F9FD"
        />
        <path
          opacity="0.12"
          d="M33.8202 122.355C32.7934 133.46 48.6495 144.642 69.3113 146.556C89.9705 148.466 107.611 140.381 108.638 129.276C109.665 118.171 93.8009 107.072 73.1389 105.161C52.4797 103.251 34.8471 111.25 33.8202 122.355Z"
          fill="#F6F7FD"
        />
        <path
          opacity="0.15"
          d="M34.4142 122.45C33.3979 133.441 49.1682 144.65 69.7219 146.551C90.2784 148.451 107.833 140.327 108.85 129.333C109.867 118.34 94.0868 107.234 73.5331 105.333C52.9765 103.432 35.4307 111.457 34.4144 122.448L34.4142 122.45Z"
          fill="#F4F6FC"
        />
        <path
          opacity="0.17"
          d="M35.0149 122.544C34.0092 133.42 49.6908 144.655 70.1418 146.546C90.5928 148.437 108.068 140.271 109.074 129.394C110.08 118.518 94.3871 107.403 73.9361 105.512C53.4851 103.621 36.0204 111.67 35.0147 122.546L35.0149 122.544Z"
          fill="#F3F4FC"
        />
        <path
          opacity="0.2"
          d="M35.6099 122.639C34.6147 133.401 50.2078 144.66 70.5533 146.541C90.8989 148.422 108.292 140.214 109.287 129.451C110.282 118.689 94.6768 107.565 74.3313 105.684C53.9858 103.802 36.6053 111.874 35.6101 122.636L35.6099 122.639Z"
          fill="#F1F3FB"
        />
        <path
          opacity="0.22"
          d="M36.2103 122.735C35.2258 133.383 50.7302 144.668 70.973 146.54C91.213 148.411 108.526 140.163 109.511 129.515C110.496 118.868 94.9772 107.734 74.7343 105.862C54.4943 103.991 37.1949 112.087 36.2103 122.735Z"
          fill="#EFF1FB"
        />
        <path
          opacity="0.24"
          d="M36.8046 122.829C35.8305 133.363 51.2493 144.672 71.3836 146.536C91.5209 148.398 108.749 140.108 109.723 129.575C110.697 119.041 95.2627 107.901 75.1285 106.036C54.9911 104.174 37.7786 112.296 36.8046 122.829Z"
          fill="#EDF0FA"
        />
        <path
          opacity="0.27"
          d="M37.397 122.922C36.4335 133.342 51.7636 144.677 71.7955 146.529C91.8273 148.381 108.976 140.049 109.939 129.63C110.903 119.21 95.5556 108.061 75.5237 106.209C55.4919 104.356 38.3604 112.503 37.397 122.922Z"
          fill="#ECEEFA"
        />
        <path
          opacity="0.29"
          d="M37.9992 123.018C37.0464 133.323 52.2877 144.684 72.2141 146.527C92.1404 148.369 109.206 139.998 110.159 129.693C111.112 119.388 95.8521 108.229 75.9257 106.386C55.9994 104.544 38.9521 112.713 37.9992 123.018Z"
          fill="#EAEDF9"
        />
        <path
          opacity="0.32"
          d="M38.5924 123.112C37.6501 133.303 52.803 144.688 72.6267 146.522C92.4475 148.354 109.434 139.941 110.376 129.75C111.319 119.559 96.1453 108.394 76.3219 106.558C56.5011 104.725 39.5349 112.919 38.5926 123.11L38.5924 123.112Z"
          fill="#E8EBF9"
        />
        <path
          opacity="0.34"
          d="M39.1871 123.205C38.2554 133.282 53.3196 144.693 73.0378 146.516C92.7559 148.34 109.657 139.884 110.589 129.81C111.52 119.737 96.4343 108.559 76.7161 106.736C56.9979 104.913 40.1186 113.131 39.1869 123.208L39.1871 123.205Z"
          fill="#E6E9F8"
        />
        <path
          opacity="0.37"
          d="M39.7873 123.301C38.8662 133.263 53.8447 144.699 73.4572 146.515C93.0699 148.328 109.891 139.834 110.812 129.871C111.734 119.909 96.7318 108.725 77.1191 106.912C57.5064 105.098 40.7082 113.342 39.7873 123.301Z"
          fill="#E5E8F8"
        />
        <path
          opacity="0.39"
          d="M40.3862 123.397C39.4756 133.245 54.3654 144.707 73.8726 146.511C93.3798 148.315 110.119 139.777 111.029 129.929C111.94 120.081 97.0254 108.888 77.5182 107.085C58.011 105.281 41.297 113.546 40.3864 123.394L40.3862 123.397Z"
          fill="#E3E6F7"
        />
        <path
          opacity="0.41"
          d="M40.982 123.492C40.082 133.226 54.8831 144.714 74.2877 146.508C93.6893 148.302 110.349 139.723 111.249 129.993C112.148 120.262 97.3209 109.059 77.9163 107.265C58.5118 105.471 41.8818 113.762 40.9818 123.495L40.982 123.492Z"
          fill="#E1E5F7"
        />
        <path
          opacity="0.44"
          d="M41.5769 123.585C40.6875 133.204 55.4002 144.716 74.6992 146.5C93.9982 148.285 110.572 139.666 111.462 130.047C112.351 120.427 97.6105 109.219 78.3115 107.434C59.0125 105.65 42.4664 113.965 41.5772 123.582L41.5769 123.585Z"
          fill="#DFE3F6"
        />
        <path
          opacity="0.46"
          d="M42.1735 123.681C41.2949 133.183 55.9215 144.724 75.115 146.499C94.3085 148.274 110.803 139.613 111.682 130.111C112.56 120.608 97.9042 109.387 78.7106 107.613C59.5171 105.838 43.0522 114.178 42.1735 123.681Z"
          fill="#DEE2F6"
        />
        <path
          opacity="0.49"
          d="M42.7641 123.775C41.896 133.163 56.4342 144.728 75.5219 146.496C94.6099 148.261 111.022 139.558 111.89 130.17C112.758 120.782 98.1889 109.554 79.1009 107.789C60.0129 106.024 43.6322 114.387 42.7638 123.778L42.7641 123.775Z"
          fill="#DCE0F5"
        />
        <path
          opacity="0.51"
          d="M43.3651 123.868C42.5075 133.142 56.957 144.733 75.9423 146.488C94.9277 148.244 111.257 139.502 112.115 130.225C112.973 120.949 98.4903 109.715 79.5049 107.959C60.5196 106.204 44.2228 114.592 43.3651 123.868Z"
          fill="#DADFF5"
        />
        <path
          opacity="0.54"
          d="M43.9595 123.964C43.1126 133.123 57.4733 144.74 76.3531 146.486C95.233 148.232 111.48 139.448 112.327 130.288C113.174 121.129 98.779 109.883 79.8991 108.137C61.0193 106.391 44.8065 114.804 43.9595 123.964Z"
          fill="#D8DDF4"
        />
        <path
          opacity="0.56"
          d="M44.5605 124.059C43.7241 133.105 57.9963 144.745 76.7735 146.482C95.5479 148.218 111.715 139.391 112.552 130.346C113.388 121.301 99.0801 110.049 80.3031 108.31C61.5288 106.574 45.3971 115.011 44.5607 124.057L44.5605 124.059Z"
          fill="#D7DCF4"
        />
        <path
          opacity="0.59"
          d="M45.1542 124.155C44.3284 133.086 58.5148 144.753 77.1836 146.48C95.8525 148.206 111.937 139.34 112.763 130.409C113.589 121.478 99.3652 110.217 80.6963 108.49C62.0275 106.764 45.98 115.224 45.154 124.158L45.1542 124.155Z"
          fill="#D5DAF3"
        />
        <path
          opacity="0.61"
          d="M45.7476 124.248C44.9324 133.065 59.0303 144.756 77.5962 146.475C96.1624 148.192 112.165 139.284 112.98 130.468C113.795 121.651 99.6587 110.38 81.0925 108.663C62.5264 106.946 46.5628 115.431 45.7476 124.248Z"
          fill="#D3D9F3"
        />
        <path
          opacity="0.63"
          d="M46.3494 124.343C45.5447 133.046 59.5539 144.763 78.0146 146.47C96.4752 148.177 112.395 139.227 113.2 130.525C114.005 121.822 99.9549 110.545 81.4945 108.835C63.0338 107.128 47.1543 115.638 46.3496 124.34L46.3494 124.343Z"
          fill="#D1D7F2"
        />
        <path
          opacity="0.66"
          d="M46.9423 124.438C46.1482 133.026 60.0687 144.77 78.4267 146.468C96.7819 148.165 112.622 139.176 113.416 130.588C114.211 122 100.248 110.713 81.8898 109.016C63.5346 107.318 47.7362 115.853 46.9421 124.441L46.9423 124.438Z"
          fill="#D0D6F2"
        />
        <path
          opacity="0.68"
          d="M47.5372 124.531C46.7537 133.004 60.5886 144.772 78.8383 146.46C97.0879 148.147 112.846 139.116 113.63 130.642C114.413 122.168 100.535 110.872 82.2849 109.185C64.0353 107.497 48.321 116.054 47.5375 124.528L47.5372 124.531Z"
          fill="#CED4F1"
        />
        <path
          opacity="0.71"
          d="M48.1356 124.626C47.3626 132.986 61.1088 144.78 79.253 146.457C97.4 148.135 113.073 139.062 113.846 130.705C114.618 122.348 100.827 111.04 82.683 109.362C64.536 107.684 48.9086 116.267 48.1356 124.626Z"
          fill="#CCD2F1"
        />
        <path
          opacity="0.73"
          d="M48.7322 124.722C47.9698 132.967 61.6272 144.788 79.6687 146.456C97.7103 148.124 113.303 139.011 114.066 130.766C114.828 122.521 101.124 111.209 83.0821 109.541C65.0406 107.873 49.4943 116.48 48.7319 124.725L48.7322 124.722Z"
          fill="#CAD1F0"
        />
        <path
          opacity="0.76"
          d="M49.3261 124.817C48.5743 132.948 62.1433 144.792 80.0793 146.451C98.0153 148.109 113.526 138.954 114.278 130.823C115.03 122.692 101.412 111.371 83.4763 109.713C65.5403 108.054 50.078 116.687 49.3261 124.817Z"
          fill="#C9CFF0"
        />
        <path
          opacity="0.78"
          d="M49.9276 124.911C49.1863 132.927 62.6666 144.797 80.5 146.446C98.3305 148.095 113.762 138.898 114.503 130.884C115.244 122.871 101.714 111.537 83.8803 109.889C66.0498 108.24 50.6686 116.897 49.9276 124.911Z"
          fill="#C7CEEF"
        />
        <path
          opacity="0.8"
          d="M50.5218 125.006C49.7911 132.908 63.1858 144.802 80.9108 146.441C98.6386 148.08 113.984 138.844 114.715 130.942C115.446 123.039 101.999 111.702 84.2745 110.063C66.5467 108.424 51.2525 117.104 50.5218 125.006Z"
          fill="#C5CCEF"
        />
        <path
          opacity="0.83"
          d="M51.122 125.102C50.4019 132.89 63.7079 144.81 81.3302 146.44C98.9525 148.069 114.219 138.791 114.939 131.003C115.659 123.215 102.3 111.868 84.6775 110.239C67.0552 108.61 51.8422 117.314 51.122 125.102Z"
          fill="#C3CBEE"
        />
        <path
          opacity="0.85"
          d="M51.7165 125.194C51.0069 132.868 64.2242 144.815 81.741 146.435C99.2579 148.054 114.442 138.734 115.151 131.063C115.86 123.392 102.589 112.034 85.0717 110.414C67.5549 108.794 52.4258 117.523 51.7165 125.194Z"
          fill="#C2C9EE"
        />
        <path
          opacity="0.88"
          d="M52.3096 125.289C51.6109 132.846 64.7394 144.819 82.1536 146.429C99.5678 148.039 114.669 138.679 115.368 131.12C116.067 123.56 102.882 112.199 85.4679 110.586C68.0538 108.975 53.0086 117.73 52.3099 125.286L52.3096 125.289Z"
          fill="#C0C8ED"
        />
        <path
          opacity="0.9"
          d="M52.9044 125.385C52.2162 132.827 65.2589 144.827 82.5647 146.427C99.8734 148.028 114.892 138.625 115.58 131.183C116.268 123.741 103.168 112.367 85.8621 110.766C68.5534 109.166 53.5925 117.942 52.9041 125.388L52.9044 125.385Z"
          fill="#BEC6ED"
        />
        <path
          opacity="0.93"
          d="M53.5082 125.481C52.8306 132.809 65.7849 144.832 82.988 146.423C100.191 148.013 115.13 138.569 115.808 131.241C116.486 123.913 103.472 112.53 86.269 110.939C69.0659 109.348 54.1861 118.15 53.5085 125.478L53.5082 125.481Z"
          fill="#BCC5EC"
        />
        <path
          opacity="0.95"
          d="M54.0995 125.573C53.4325 132.787 66.298 144.837 83.3957 146.417C100.493 147.998 115.35 138.515 116.017 131.298C116.684 124.082 103.758 112.695 86.6603 111.111C69.5626 109.53 54.7668 118.356 54.0998 125.57L54.0995 125.573Z"
          fill="#BBC3EC"
        />
        <path
          opacity="0.98"
          d="M54.6993 125.669C54.0428 132.769 66.8196 144.845 83.8146 146.416C100.81 147.988 115.584 138.462 116.24 131.362C116.897 124.263 104.057 112.864 87.0624 111.292C70.0674 109.721 55.3555 118.572 54.699 125.672L54.6993 125.669Z"
          fill="#B9C2EB"
        />
        <path
          d="M55.2942 125.763C54.6483 132.749 67.3367 144.848 84.2262 146.41C101.116 147.972 115.807 138.404 116.453 131.419C117.099 124.433 104.347 113.025 87.4575 111.463C70.568 109.902 55.9404 118.775 55.2945 125.761L55.2942 125.763Z"
          fill="#B7C0EB"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          opacity="0.02"
          d="M1.01017 114.18C-0.467872 130.165 21.8336 145.323 50.8221 148.003C79.8134 150.684 104.521 139.792 105.991 123.887C107.462 107.983 85.1658 92.7673 56.1774 90.0868C27.1861 87.4061 2.48082 98.2753 1.01044 114.177L1.01017 114.18Z"
          fill="#FDFDFF"
        />
        <path
          opacity="0.05"
          d="M2.23228 114.377C0.761365 130.285 22.9491 145.398 51.795 148.065C80.6408 150.732 105.238 139.784 106.694 124.039C108.15 108.291 85.9732 93.0642 57.1273 90.397C28.2814 87.7297 3.68813 98.6323 2.23228 114.377Z"
          fill="#FBFCFE"
        />
        <path
          opacity="0.07"
          d="M3.45199 114.571C1.98821 130.401 24.0622 145.469 52.7626 148.123C81.4659 150.777 105.948 139.772 107.389 124.184C108.831 108.597 86.7727 93.3543 58.0723 90.7005C29.369 88.0464 4.89332 98.983 3.45199 114.571Z"
          fill="#FAFAFE"
        />
        <path
          opacity="0.1"
          d="M4.67282 114.767C3.21617 130.52 25.1764 145.543 53.7343 148.183C82.2922 150.824 106.664 139.763 108.091 124.332C109.518 108.902 87.5791 93.6474 59.0212 91.0067C30.4633 88.3661 6.09961 99.336 4.67282 114.767Z"
          fill="#F8F9FD"
        />
        <path
          opacity="0.12"
          d="M5.89644 114.96C4.44693 130.636 26.2934 145.614 54.7059 148.241C83.1212 150.869 107.378 139.75 108.79 124.477C110.202 109.204 88.3822 93.9403 59.97 91.3103C31.5548 88.6828 7.30897 99.6839 5.89644 114.96Z"
          fill="#F6F7FD"
        />
        <path
          opacity="0.15"
          d="M7.11365 115.157C5.67127 130.756 27.404 145.689 55.6739 148.303C83.9438 150.917 108.091 139.742 109.488 124.626C110.886 109.51 89.185 94.2344 60.9151 91.6204C32.6452 89.0064 8.51139 100.041 7.11339 115.16L7.11365 115.157Z"
          fill="#F4F6FC"
        />
        <path
          opacity="0.17"
          d="M8.34119 115.351C6.90594 130.873 28.525 145.76 56.6494 148.361C84.7738 150.961 108.808 139.73 110.191 124.771C111.574 109.812 89.9923 94.5245 61.8679 91.924C33.7406 89.3232 9.7244 100.391 8.34119 115.351Z"
          fill="#F3F4FC"
        />
        <path
          opacity="0.2"
          d="M9.55517 115.547C8.12706 130.991 29.6323 145.834 57.6142 148.421C85.5961 151.009 109.517 139.721 110.886 124.919C112.255 110.117 90.7918 94.8176 62.81 92.2302C34.8281 89.6428 10.9239 100.745 9.55517 115.547Z"
          fill="#F1F3FB"
        />
        <path
          opacity="0.22"
          d="M10.7838 115.741C9.36279 131.108 30.7543 145.906 58.5908 148.48C86.4272 151.054 110.236 139.71 111.593 125.065C112.947 110.42 91.6031 95.1086 63.7666 92.5347C35.9302 89.9608 12.1379 101.096 10.7838 115.741Z"
          fill="#EFF1FB"
        />
        <path
          opacity="0.24"
          d="M11.9996 115.937C10.5855 131.23 31.8636 145.98 59.5575 148.54C87.2513 151.101 110.947 139.701 112.287 125.213C113.627 110.725 92.4014 95.4045 64.7078 92.8409C37.0139 90.2802 13.3393 101.449 11.9996 115.937Z"
          fill="#EDF0FA"
        />
        <path
          opacity="0.27"
          d="M13.2214 116.131C11.8145 131.347 32.9788 146.052 60.5301 148.599C88.0785 151.146 111.665 139.69 112.99 125.359C114.315 111.028 93.2087 95.6956 65.6577 93.1452C38.1092 90.5979 14.5465 101.8 13.2214 116.131Z"
          fill="#ECEEFA"
        />
        <path
          opacity="0.29"
          d="M14.4453 116.328C13.0455 131.467 34.0961 146.126 61.5019 148.66C88.9078 151.194 112.378 139.68 113.689 125.507C115 111.334 94.0124 95.9887 66.6065 93.4546C39.2007 90.9205 15.7556 102.157 14.4453 116.328Z"
          fill="#EAEDF9"
        />
        <path
          opacity="0.32"
          d="M15.6672 116.521C14.2744 131.583 35.2113 146.198 62.4746 148.718C89.735 151.239 113.096 139.669 114.392 125.653C115.688 111.637 94.8197 96.2798 67.5565 93.7589C40.296 91.2382 16.9629 102.508 15.6672 116.521Z"
          fill="#E8EBF9"
        />
        <path
          opacity="0.34"
          d="M16.8869 116.715C15.5013 131.7 36.3244 146.269 63.4422 148.776C90.5601 151.284 113.805 139.657 115.087 125.798C116.368 111.942 95.6193 96.5699 68.5014 94.0624C41.3836 91.555 18.1681 102.859 16.8869 116.715Z"
          fill="#E6E9F8"
        />
        <path
          opacity="0.37"
          d="M18.1116 116.911C16.7332 131.819 37.4428 146.34 64.4178 148.837C91.3902 151.331 114.526 139.648 115.793 125.946C117.059 112.247 96.4295 96.863 69.4543 94.3687C42.4818 91.8746 19.3783 103.212 18.1116 116.911Z"
          fill="#E5E8F8"
        />
        <path
          opacity="0.39"
          d="M19.3313 117.104C17.96 131.935 38.5559 146.411 65.3855 148.895C92.2153 151.376 115.236 139.633 116.488 126.091C117.74 112.549 97.2288 97.1559 70.3992 94.6722C43.5694 92.1914 20.5835 103.562 19.3313 117.104Z"
          fill="#E3E6F7"
        />
        <path
          opacity="0.41"
          d="M20.5564 117.301C19.1922 132.055 39.6743 146.486 66.3613 148.956C93.0457 151.424 115.956 139.625 117.194 126.24C118.431 112.855 98.0393 97.45 71.3521 94.9824C44.6676 92.515 21.794 103.917 20.5561 117.304L20.5564 117.301Z"
          fill="#E1E5F7"
        />
        <path
          opacity="0.44"
          d="M21.7722 117.495C20.4151 132.171 40.7835 146.557 67.3251 149.014C93.8669 151.468 116.662 139.613 117.885 126.385C119.108 113.157 98.835 97.7401 72.2931 95.2859C45.7513 92.8317 22.9953 104.267 21.7722 117.495Z"
          fill="#DFE3F6"
        />
        <path
          opacity="0.46"
          d="M22.9937 117.691C21.6438 132.29 41.8984 146.631 68.2977 149.072C94.6941 151.512 117.379 139.601 118.588 126.53C119.796 113.459 99.6423 98.0302 73.243 95.5892C46.8466 93.1484 24.2026 104.617 22.994 117.688L22.9937 117.691Z"
          fill="#DEE2F6"
        />
        <path
          opacity="0.49"
          d="M24.2134 117.884C22.8706 132.406 43.0144 146.702 69.2654 149.13C95.5192 151.557 118.089 139.589 119.283 126.675C120.477 113.762 100.439 98.3201 74.188 95.8927C47.9341 93.4652 25.4077 104.968 24.2137 117.882L24.2134 117.884Z"
          fill="#DCE0F5"
        />
        <path
          opacity="0.51"
          d="M25.4353 118.081C24.0993 132.529 44.1296 146.777 70.238 149.191C96.3465 151.605 118.806 139.58 119.986 126.824C121.165 114.068 101.246 98.6169 75.1379 96.1999C49.0295 93.7858 26.615 105.322 25.4355 118.078L25.4353 118.081Z"
          fill="#DADFF5"
        />
        <path
          opacity="0.54"
          d="M26.6582 118.275C25.3294 132.646 45.2459 146.848 71.2089 149.249C97.1748 151.65 119.519 139.568 120.684 126.972C121.849 114.373 102.049 98.91 76.0858 96.5064C50.12 94.1055 27.8232 105.676 26.6582 118.275Z"
          fill="#D8DDF4"
        />
        <path
          opacity="0.56"
          d="M27.8841 118.472C26.5625 132.765 46.3653 146.923 72.1857 149.311C98.0061 151.698 120.24 139.56 121.391 127.121C122.541 114.679 102.86 99.2041 77.0396 96.8166C51.2192 94.429 29.0343 106.033 27.8841 118.472Z"
          fill="#D7DCF4"
        />
        <path
          opacity="0.59"
          d="M29.1 118.664C27.7854 132.881 47.4745 146.993 73.1495 149.367C98.8273 151.742 120.946 139.547 122.082 127.265C123.217 114.983 103.656 99.4932 77.9807 97.1191C52.3028 94.7448 30.2356 106.382 29.1 118.664Z"
          fill="#D5DAF3"
        />
        <path
          opacity="0.61"
          d="M30.3169 118.861C29.0095 133.001 48.5848 147.068 74.1172 149.429C99.6496 151.79 121.659 139.539 122.78 127.414C123.901 115.289 104.458 99.7872 78.9257 97.4263C53.3933 95.0655 31.438 106.736 30.3169 118.861Z"
          fill="#D3D9F3"
        />
        <path
          opacity="0.63"
          d="M31.5444 119.055C30.2441 133.117 49.7057 147.139 75.0927 149.487C100.483 151.835 122.376 139.527 123.483 127.559C124.589 115.591 105.265 100.077 79.8785 97.7299C54.4886 95.3822 32.651 107.087 31.5444 119.055Z"
          fill="#D1D7F2"
        />
        <path
          opacity="0.66"
          d="M32.7662 119.252C31.4731 133.237 50.821 147.214 76.0654 149.548C101.31 151.883 123.093 139.519 124.185 127.708C125.277 115.897 106.073 100.374 80.8284 98.0371C55.584 95.7028 33.8583 107.441 32.7662 119.252Z"
          fill="#D0D6F2"
        />
        <path
          opacity="0.68"
          d="M33.9824 119.445C32.6964 133.353 51.9305 147.285 77.0295 149.606C102.131 151.927 123.802 139.507 124.88 127.853C125.957 116.199 106.871 100.664 81.7724 98.3436C56.6705 96.0225 35.0599 107.792 33.9821 119.448L33.9824 119.445Z"
          fill="#CED4F1"
        />
        <path
          opacity="0.71"
          d="M35.207 119.641C33.9282 133.472 53.0485 147.359 78.0049 149.667C102.961 151.974 124.52 139.497 125.583 128.001C126.646 116.504 107.679 100.957 82.7223 98.6498C57.7659 96.3422 36.2701 108.145 35.207 119.641Z"
          fill="#CCD2F1"
        />
        <path
          opacity="0.73"
          d="M36.4289 119.835C35.1571 133.589 54.1637 147.431 78.9776 149.725C103.791 152.02 125.237 139.486 126.285 128.147C127.334 116.808 108.486 101.248 83.6722 98.9541C58.8583 96.6596 37.4774 108.496 36.4289 119.835Z"
          fill="#CAD1F0"
        />
        <path
          opacity="0.76"
          d="M37.6486 120.032C36.384 133.708 55.2769 147.505 79.9453 149.786C104.614 152.067 125.946 139.477 126.98 128.295C128.014 117.113 109.286 101.542 84.6172 99.2605C59.9488 96.9796 38.6826 108.85 37.6486 120.032Z"
          fill="#C9CFF0"
        />
        <path
          opacity="0.78"
          d="M38.8694 120.226C37.612 133.825 56.3911 147.577 80.9169 149.845C105.443 152.112 126.663 139.466 127.682 128.441C128.702 117.416 110.092 101.835 85.5661 99.5648C61.0403 97.297 39.8889 109.201 38.8694 120.226Z"
          fill="#C7CEEF"
        />
        <path
          opacity="0.8"
          d="M40.0933 120.421C38.843 133.943 57.5086 147.647 81.8888 149.905C106.269 152.159 127.377 139.456 128.381 128.588C129.386 117.72 110.895 102.128 86.515 99.8732C62.1346 97.6189 41.098 109.556 40.093 120.424L40.0933 120.421Z"
          fill="#C5CCEF"
        />
        <path
          opacity="0.83"
          d="M41.3151 120.615C40.0717 134.063 58.6238 147.719 82.8614 149.963C107.096 152.204 128.094 139.445 129.084 128.734C130.075 118.023 111.703 102.419 87.4649 100.178C63.2299 97.9366 42.3052 109.907 41.3148 120.618L41.3151 120.615Z"
          fill="#C3CBEE"
        />
        <path
          opacity="0.85"
          d="M42.5339 120.812C41.2975 134.182 59.736 147.793 83.8281 150.024C107.921 152.252 128.803 139.436 129.778 128.882C130.754 118.328 112.501 102.712 88.4088 100.484C64.3164 98.2563 43.5094 110.261 42.5339 120.812Z"
          fill="#C2C9EE"
        />
        <path
          opacity="0.88"
          d="M43.7557 121.006C42.5265 134.299 60.8512 147.865 84.8007 150.082C108.748 152.297 129.52 139.424 130.481 129.028C131.443 118.631 113.309 103.003 89.3588 100.788C65.4118 98.574 44.7167 110.612 43.7557 121.006Z"
          fill="#C0C8ED"
        />
        <path
          opacity="0.9"
          d="M44.979 121.202C43.757 134.419 61.9679 147.939 85.7723 150.14C109.577 152.341 130.233 139.412 131.18 129.173C132.127 118.933 114.112 103.293 90.3076 101.092C66.5032 98.8907 45.9258 110.963 44.9793 121.199L44.979 121.202Z"
          fill="#BEC6ED"
        />
        <path
          opacity="0.93"
          d="M46.2009 121.396C44.9859 134.535 63.0831 148.011 86.745 150.199C110.404 152.387 130.951 139.401 131.883 129.319C132.815 119.237 114.919 103.587 91.2576 101.396C67.5986 99.2084 47.1331 111.314 46.2011 121.393L46.2009 121.396Z"
          fill="#BCC5EC"
        />
        <path
          opacity="0.95"
          d="M47.4159 121.592C46.2081 134.654 64.1916 148.084 87.708 150.259C111.224 152.433 131.656 139.391 132.573 129.466C133.491 119.541 115.714 103.879 92.1976 101.705C68.6812 99.5301 48.3334 111.669 47.4159 121.592Z"
          fill="#BBC3EC"
        />
        <path
          opacity="0.98"
          d="M48.6417 121.786C47.441 134.771 65.3107 148.156 88.6846 150.317C112.056 152.478 132.377 139.377 133.28 129.612C134.183 119.847 116.525 104.17 93.1515 102.009C69.7805 99.8478 49.5449 112.018 48.6419 121.783L48.6417 121.786Z"
          fill="#B9C2EB"
        />
        <path
          d="M49.8616 121.979C48.6681 134.887 66.4241 148.227 89.6525 150.375C112.881 152.523 133.087 139.365 133.975 129.76C134.863 120.155 117.325 104.463 94.0964 102.315C70.868 100.167 50.7501 112.371 49.8616 121.979Z"
          fill="#B7C0EB"
        />
      </g>
      <path
        d="M152.835 114.971C151.865 131.878 132.389 141.3 117.909 144.771C104.464 147.986 90.3011 148.154 76.7569 145.429C60.0576 142.326 38.4159 131.04 38.5419 114.003L38.4999 121.412C38.3471 137.657 58.3236 148.893 74.5262 152.36C86.9017 155.196 99.8616 155.483 112.367 153.328C126.419 150.806 143.313 144.408 150.433 131.159C151.636 128.809 152.446 126.253 152.706 123.62C152.874 122.885 152.828 115.499 152.847 114.328C152.847 114.543 152.839 114.757 152.832 114.971H152.835Z"
        fill="url(#paint0_linear_5273_86410)"
      />
      <path
        d="M135.977 92.2254C158.371 105.179 158.49 126.178 136.241 139.132C113.995 152.086 77.8048 152.086 55.4143 139.132C33.0201 126.185 32.9017 105.183 55.1508 92.2292C77.3999 79.2752 113.587 79.2752 135.977 92.2292V92.2254ZM60.2729 136.308C79.9323 147.677 111.814 147.681 131.348 136.308C150.877 124.934 150.774 106.431 131.115 95.0611C111.455 83.6914 79.5694 83.6876 60.036 95.0611C40.5027 106.435 40.6134 124.938 60.269 136.311"
        fill="white"
      />
      <path
        d="M135.977 91.7117C158.371 104.666 158.49 125.664 136.241 138.618C113.995 151.572 77.8048 151.572 55.4143 138.618C33.0201 125.672 32.9017 104.67 55.1508 91.7156C77.3999 78.7615 113.587 78.7615 135.977 91.7156V91.7117ZM60.2729 135.794C79.9323 147.164 111.814 147.167 131.348 135.794C150.877 124.42 150.774 105.917 131.115 94.5475C111.455 83.1777 79.5694 83.1739 60.0361 94.5475C40.5027 105.921 40.6134 124.424 60.269 135.798"
        fill="url(#paint1_linear_5273_86410)"
      />
      <path
        d="M134.428 92.2154C155.757 104.503 155.87 124.496 134.681 136.783C113.488 149.074 78.8986 149.07 57.5735 136.783C36.2444 124.5 36.1238 104.507 57.3166 92.2154C78.5055 79.9282 113.103 79.9282 134.428 92.2154Z"
        fill="url(#paint2_linear_5273_86410)"
      />
      <path
        d="M101.513 120.787C101.959 116.465 98.8167 112.6 94.4947 112.154L55.6152 108.145C50.1757 107.585 45.8373 112.607 47.1834 117.908C47.9958 121.106 50.7185 123.458 54.0016 123.797L92.881 127.805C97.203 128.251 101.068 125.109 101.513 120.787Z"
        fill="url(#paint3_linear_5273_86410)"
      />
      <path
        d="M169.183 0.819473C173.912 0.111246 184.335 6.41136 188.121 13.1755C189.415 15.487 188.56 18.2256 186.924 20.3095L106.32 123.03C105.969 123.477 105.582 123.892 105.161 124.273L104.426 124.938C100.57 128.426 94.6838 128.377 90.8864 124.825L51.5639 88.0423C47.1932 83.9539 47.3682 76.9677 51.9382 73.1034L62.341 64.3066C66.0512 61.1693 71.4795 61.1529 75.2086 64.2677L94.9126 80.7258C95.3346 81.0782 95.9619 81.0239 96.3171 80.6042L147.149 20.5344C147.149 20.5344 163.909 1.60925 169.183 0.819473Z"
        fill="url(#paint4_linear_5273_86410)"
      />
      <path
        d="M170.417 9.62463C176.072 4.32668 186.298 10.8582 187.646 16.3745C187.935 17.5566 187.333 18.7099 186.561 19.6509L104.509 119.729C101.916 122.891 97.1769 123.167 94.2346 120.328L59.9989 87.2902C56.8681 84.2689 57.2228 79.1536 60.7407 76.5933L70.8131 69.2628C73.4731 67.327 77.1222 67.5046 79.5815 69.6897L100.72 88.4709C101.577 89.2319 102.896 89.1198 103.612 88.2255C132.581 52.0452 163.553 16.0557 170.417 9.62463Z"
        fill="url(#paint5_linear_5273_86410)"
      />
      <path
        d="M63.9311 91.1144L101.004 126.196C101.424 126.593 102.092 126.553 102.461 126.108L186.543 24.7069C189.134 21.5822 188.533 16.916 185.234 14.5504L180.318 11.0246C177.317 8.87272 173.161 9.42163 170.822 12.2787L104.216 93.6362C103.487 94.5267 102.159 94.6197 101.313 93.8394L80.9759 75.0815C78.4631 72.7638 74.6439 72.6001 71.9419 74.6941L64.4544 80.4971C61.0611 83.1269 60.8129 88.1636 63.9311 91.1144Z"
        fill="url(#paint6_linear_5273_86410)"
        stroke="white"
        strokeWidth="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5273_86410"
          x1="38.057"
          y1="121.408"
          x2="152.764"
          y2="122.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7C0EB" />
          <stop offset="0.05" stopColor="#C9CFF1" />
          <stop offset="0.11" stopColor="#D8DCF6" />
          <stop offset="0.18" stopColor="#E1E4FA" />
          <stop offset="0.29" stopColor="#E4E7FB" />
          <stop offset="0.76" stopColor="#F4F5FD" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5273_86410"
          x1="38.5226"
          y1="115.202"
          x2="152.708"
          y2="115.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B1BAE3" />
          <stop offset="1" stopColor="#F2F3FD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5273_86410"
          x1="150.361"
          y1="114.536"
          x2="41.4759"
          y2="114.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6F7FF" />
          <stop offset="1" stopColor="#E4EAFE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_5273_86410"
          x1="101.298"
          y1="122.873"
          x2="49.1275"
          y2="117.494"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A6B0E0" />
          <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_5273_86410"
          x1="162.224"
          y1="-7.29863"
          x2="68.5397"
          y2="106.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7DAF3" />
          <stop offset="0.05" stopColor="#F0F2FF" />
          <stop offset="0.272918" stopColor="#E9ECFF" />
          <stop offset="0.48906" stopColor="#E4E7FB" />
          <stop offset="0.731253" stopColor="#9FA9D8" />
          <stop offset="0.797878" stopColor="#D6DCF8" />
          <stop offset="0.934262" stopColor="#CAD1EF" />
          <stop offset="1" stopColor="#9FA9D8" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_5273_86410"
          x1="148.999"
          y1="-15"
          x2="119.347"
          y2="128.935"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FCFCFC" />
          <stop offset="0.837178" stopColor="#E5E8FB" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_5273_86410"
          x1="182.625"
          y1="21.4309"
          x2="98.5222"
          y2="151.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#58DFDA" />
          <stop offset="1" stopColor="#1249A2" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      width="197"
      height="156"
      viewBox="0 0 197 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M159.252 117.359C158.282 134.266 139.39 141.92 124.91 145.391C111.465 148.605 97.3022 148.774 83.7579 146.049C67.0587 142.945 46.284 131.292 46.4138 114.255L45.5048 122.031C45.352 138.276 65.3284 149.512 81.5311 152.979C93.9066 155.815 106.866 156.102 119.372 153.948C133.424 151.426 150.318 145.027 157.438 131.778C158.641 129.429 159.451 126.872 159.71 124.239C159.878 123.505 158.794 116.371 158.817 115.2C158.817 115.414 159.264 117.144 159.256 117.355L159.252 117.359Z"
        fill="#08192D"
      />
      <path
        d="M159.835 114.971C158.865 131.878 139.389 141.3 124.909 144.771C111.464 147.986 97.3011 148.154 83.7569 145.429C67.0576 142.326 45.4159 131.04 45.5419 114.003L45.4999 121.412C45.3471 137.657 65.3236 148.893 81.5262 152.36C93.9017 155.196 106.862 155.483 119.367 153.328C133.419 150.806 150.313 144.408 157.433 131.159C158.636 128.809 159.446 126.253 159.706 123.62C159.874 122.885 159.828 115.499 159.847 114.328C159.847 114.543 159.839 114.757 159.832 114.971H159.835Z"
        fill="url(#paint0_linear_6823_8200)"
      />
      <path
        d="M142.977 92.2254C165.371 105.179 165.49 126.178 143.241 139.132C120.995 152.086 84.8048 152.086 62.4143 139.132C40.0201 126.185 39.9017 105.183 62.1508 92.2292C84.3999 79.2752 120.587 79.2752 142.977 92.2292V92.2254ZM67.2729 136.308C86.9323 147.677 118.814 147.681 138.348 136.308C157.877 124.934 157.774 106.431 138.115 95.0611C118.455 83.6914 86.5694 83.6876 67.036 95.0611C47.5027 106.435 47.6134 124.938 67.269 136.311"
        fill="#0D1C4B"
      />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          opacity="0.02"
          d="M30.4114 111.321C28.5207 122.781 43.9008 134.987 64.7867 138.433C85.6726 141.879 104.159 135.26 106.049 123.8C107.94 112.341 92.5572 100.152 71.6712 96.7056C50.7853 93.2597 32.3021 99.8616 30.4114 111.321Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.05"
          d="M30.9939 111.458C29.1223 122.802 44.4116 135.031 65.193 138.46C85.9771 141.889 104.381 135.221 106.253 123.878C108.124 112.535 92.8294 100.339 72.0481 96.9107C51.2667 93.482 32.8654 100.115 30.9939 111.458Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.07"
          d="M31.5893 111.594C29.7364 122.824 44.9358 135.071 65.6154 138.483C86.2951 141.895 104.622 135.183 106.476 123.95C108.329 112.717 93.1208 100.524 72.4416 97.1094C51.7619 93.6975 33.4426 100.361 31.5897 111.592L31.5893 111.594Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.1"
          d="M32.1761 111.732C30.3419 122.849 45.4509 135.115 66.026 138.51C86.6011 141.904 104.849 135.144 106.683 124.027C108.518 112.911 93.3974 100.712 72.8223 97.3174C52.2472 93.9227 34.0103 100.615 32.1756 111.734L32.1761 111.732Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.12"
          d="M32.7602 111.869C30.9448 122.872 45.9638 135.156 66.4368 138.537C86.9073 141.914 105.079 135.107 106.895 124.103C108.71 113.099 93.6775 100.898 73.2041 97.52C52.7335 94.1426 34.5757 100.865 32.7602 111.869Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.15"
          d="M33.3467 112.006C31.5499 122.896 46.4814 135.2 66.8474 138.56C87.2163 141.921 105.306 135.068 107.103 124.175C108.9 113.282 93.9518 101.079 73.5858 97.7192C53.2169 94.3586 35.1439 101.113 33.3471 112.003L33.3467 112.006Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.17"
          d="M33.9386 112.142C32.1605 122.919 47.0016 135.243 67.2659 138.587C87.5303 141.93 105.543 135.03 107.321 124.252C109.099 113.475 94.2387 101.27 73.9744 97.9268C53.7101 94.5834 35.7162 101.368 33.9381 112.145L33.9386 112.142Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.2"
          d="M34.525 112.279C32.7656 122.943 47.5168 135.284 67.6766 138.611C87.8364 141.937 105.77 134.988 107.53 124.324C109.289 113.66 94.5158 101.452 74.3561 98.126C54.1963 94.7998 36.2849 101.612 34.5255 112.276L34.525 112.279Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.22"
          d="M35.1174 112.417C33.3767 122.968 48.0376 135.329 68.0956 138.639C88.1508 141.948 106.008 134.954 107.749 124.404C109.489 113.853 94.8037 101.642 74.7457 98.3325C54.6905 95.0236 36.8582 101.867 35.1174 112.417Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.24"
          d="M35.7033 112.555C33.9813 122.992 48.5551 135.371 68.5053 138.665C88.4588 141.957 106.234 134.916 107.956 124.478C109.678 114.041 95.0766 101.829 75.1264 98.5346C55.1729 95.2425 37.4254 102.117 35.7033 112.555Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.27"
          d="M36.2885 112.69C34.5851 123.014 49.0685 135.413 68.9175 138.688C88.7665 141.963 106.465 134.873 108.169 124.549C109.872 114.225 95.3581 102.01 75.5092 98.7353C55.6602 95.4605 37.9919 102.366 36.2885 112.69Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.29"
          d="M36.8826 112.828C35.1979 123.039 49.591 135.458 69.3354 138.715C89.0799 141.973 106.699 134.839 108.384 124.628C110.068 114.417 95.6421 102.199 75.8977 98.9414C56.1533 95.6838 38.5673 102.617 36.8826 112.828Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.32"
          d="M37.4663 112.965C35.8003 123.063 50.1035 135.499 69.7462 138.74C89.3861 141.98 106.929 134.798 108.595 124.7C110.261 114.603 95.9217 102.385 76.2795 99.1411C56.6396 95.9007 39.1328 102.864 37.4668 112.962L37.4663 112.965Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.34"
          d="M38.0532 113.099C36.4058 123.084 50.6186 135.54 70.1568 138.763C89.695 141.987 107.156 134.757 108.803 124.775C110.449 114.793 96.1984 102.57 76.6602 99.3462C57.122 96.1226 39.7 103.118 38.0527 113.102L38.0532 113.099Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.37"
          d="M38.6451 113.239C37.0165 123.11 51.1422 135.583 70.5754 138.793C90.009 141.999 107.393 134.724 109.022 124.853C110.65 114.981 96.4834 102.757 77.0498 99.5507C57.6162 96.3444 40.2733 103.37 38.6451 113.239Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.39"
          d="M39.2355 113.377C37.6255 123.135 51.6608 135.628 70.9899 138.817C90.319 142.006 107.624 134.684 109.234 124.925C110.844 115.167 96.7645 102.94 77.4354 99.7509C58.1063 96.5618 40.8459 103.616 39.2359 113.374L39.2355 113.377Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.41"
          d="M39.8235 113.514C38.2322 123.159 52.1772 135.672 71.4045 138.845C90.6291 142.016 107.858 134.646 109.448 125.004C111.039 115.362 97.0475 103.132 77.8201 99.9594C58.5928 96.7871 41.4143 103.872 39.823 113.517L39.8235 113.514Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.44"
          d="M40.4108 113.648C38.8382 123.18 52.6933 135.71 71.8161 138.865C90.939 142.02 108.085 134.605 109.658 125.073C111.23 115.541 97.3256 103.311 78.2028 100.156C59.08 97.0006 41.9834 104.116 40.4113 113.645L40.4108 113.648Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.46"
          d="M40.9984 113.786C39.4449 123.202 53.212 135.756 72.2303 138.893C91.2486 142.031 108.318 134.568 109.872 125.152C111.425 115.737 97.6058 103.5 78.5875 100.362C59.5692 97.2244 42.5519 104.371 40.9984 113.786Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.49"
          d="M41.5809 113.923C40.0461 123.226 53.7233 135.797 72.6365 138.92C91.5503 142.041 108.541 134.529 110.076 125.227C111.61 115.925 97.8781 103.688 78.9643 100.567C60.0506 97.4468 43.1156 104.621 41.5804 113.926L41.5809 113.923Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.51"
          d="M42.1734 114.059C40.6573 123.248 54.2441 135.839 73.0561 138.942C91.8681 142.046 108.779 134.49 110.296 125.298C111.812 116.106 98.1669 103.869 79.3549 100.765C60.5429 97.6613 43.6899 104.867 42.1734 114.059Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.54"
          d="M42.7597 114.196C41.2623 123.272 54.7587 135.883 73.4662 138.969C92.1737 142.056 109.005 134.451 110.503 125.376C112 116.3 98.4431 104.057 79.7356 100.97C61.0282 97.8836 44.2571 105.12 42.7597 114.196Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.56"
          d="M43.3522 114.335C41.8735 123.297 55.28 135.926 73.8858 138.995C92.4887 142.065 109.244 134.413 110.723 125.45C112.202 116.488 98.7315 104.244 80.1262 101.172C61.5233 98.1025 44.8314 105.369 43.3527 114.332L43.3522 114.335Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.59"
          d="M43.9381 114.472C42.478 123.321 55.797 135.97 74.2954 139.022C92.7938 142.074 109.47 134.377 110.93 125.528C112.39 116.678 99.0043 104.432 80.5059 101.38C62.0076 98.3278 45.3981 105.623 43.9376 114.475L43.9381 114.472Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.61"
          d="M44.5232 114.606C43.0818 123.342 56.3109 136.008 74.7071 139.046C93.1038 142.082 109.7 134.337 111.142 125.601C112.583 116.864 99.2854 104.615 80.8887 101.579C62.492 98.5443 45.9645 105.87 44.5232 114.606Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.63"
          d="M45.1164 114.745C43.6937 123.368 56.8325 136.054 75.1246 139.072C93.4167 142.09 109.934 134.297 111.357 125.674C112.78 117.051 99.5689 104.801 81.2772 101.781C62.9851 98.7627 46.5396 106.12 45.1169 114.742L45.1164 114.745Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.66"
          d="M45.7015 114.882C44.2975 123.391 57.3459 136.097 75.5363 139.098C93.7239 142.099 110.165 134.262 111.569 125.752C112.973 117.242 99.8494 104.989 81.659 101.988C63.4715 98.9874 47.1051 106.375 45.7011 114.884L45.7015 114.882Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.68"
          d="M46.2879 115.017C44.9026 123.413 57.8639 136.137 75.9469 139.12C94.03 142.104 110.391 134.218 111.777 125.822C113.162 117.425 100.124 105.169 82.0407 102.185C63.9577 99.2019 47.6737 106.617 46.2884 115.014L46.2879 115.017Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.71"
          d="M46.8782 115.155C45.5116 123.438 58.3825 136.181 76.361 139.148C94.3423 142.114 110.622 134.181 111.988 125.9C113.354 117.62 100.404 105.358 82.4253 102.391C64.444 99.4248 48.2448 106.872 46.8782 115.155Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.73"
          d="M47.4657 115.292C46.1178 123.462 58.8983 136.225 76.7751 139.175C94.6519 142.124 110.855 134.146 112.203 125.976C113.551 117.806 100.687 105.547 82.8101 102.597C64.9333 99.6476 48.8132 107.125 47.4653 115.295L47.4657 115.292Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.76"
          d="M48.0522 115.43C46.7229 123.487 59.4135 136.267 77.1858 139.2C94.958 142.132 111.082 134.105 112.411 126.049C113.74 117.992 100.964 105.729 83.1918 102.797C65.4195 99.865 49.3814 107.373 48.0522 115.43Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.78"
          d="M48.6446 115.565C47.334 123.509 59.9343 136.309 77.6048 139.225C95.2725 142.14 111.32 134.066 112.63 126.125C113.94 118.185 101.252 105.916 83.5814 103.001C65.9137 100.086 49.9547 107.625 48.6446 115.565Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.8"
          d="M49.2305 115.704C47.9386 123.534 60.4518 136.352 78.0149 139.25C95.5809 142.148 111.546 134.028 112.838 126.198C114.129 118.368 101.525 106.102 83.9621 103.204C66.3961 100.306 50.5224 107.873 49.2305 115.704Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.83"
          d="M49.8234 115.842C48.5502 123.559 60.973 136.397 78.4345 139.278C95.8959 142.159 111.784 133.992 113.058 126.275C114.331 118.558 101.814 106.289 84.3527 103.408C66.8912 100.527 51.0967 108.125 49.8234 115.842Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.85"
          d="M50.4098 115.976C49.1553 123.58 61.4877 136.438 78.8446 139.302C96.2015 142.165 112.011 133.95 113.265 126.349C114.519 118.748 102.09 106.473 84.7334 103.61C67.3765 100.746 51.6639 108.375 50.4098 115.976Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.88"
          d="M50.9945 116.113C49.7591 123.601 62.0012 136.479 79.2563 139.326C96.5115 142.173 112.241 133.912 113.477 126.422C114.713 118.931 102.371 106.659 85.1161 103.809C67.861 100.962 52.2303 108.623 50.9949 116.11L50.9945 116.113Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.9"
          d="M51.5803 116.25C50.3636 123.625 62.5182 136.523 79.666 139.353C96.8166 142.182 112.467 133.874 113.684 126.5C114.901 119.125 102.644 106.847 85.4959 104.017C68.3452 101.188 52.797 108.876 51.5799 116.253L51.5803 116.25Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.93"
          d="M52.1757 116.389C50.9777 123.651 63.0423 136.566 80.0884 139.379C97.1345 142.191 112.709 133.836 113.907 126.574C115.105 119.313 102.935 107.031 85.8894 104.219C68.8433 101.407 53.3742 109.125 52.1762 116.387L52.1757 116.389Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.95"
          d="M52.7587 116.524C51.5794 123.672 63.5536 136.607 80.4952 139.402C97.4367 142.198 112.931 133.797 114.111 126.646C115.291 119.495 103.208 107.216 86.2672 104.418C69.3256 101.623 53.9385 109.373 52.7592 116.521L52.7587 116.524Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.98"
          d="M53.3506 116.662C52.19 123.697 64.0739 136.652 80.9137 139.431C97.7535 142.209 113.169 133.76 114.33 126.726C115.49 119.691 103.496 107.406 86.6558 104.628C69.816 101.849 54.5108 109.63 53.3502 116.665L53.3506 116.662Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          d="M53.937 116.799C52.7951 123.72 64.5891 136.693 81.3244 139.454C98.0597 142.216 113.396 133.719 114.538 126.797C115.68 119.876 103.773 107.588 87.0375 104.827C70.3022 102.066 55.0795 109.875 53.9375 116.796L53.937 116.799Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          opacity="0.02"
          d="M0.61705 101.377C-1.99618 117.216 19.1686 133.925 47.8924 138.664C76.619 143.403 102.04 134.3 104.64 118.54C107.24 102.78 86.0845 86.0152 57.3607 81.2761C28.6341 76.5366 3.2172 85.6179 0.617517 101.375L0.61705 101.377Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.05"
          d="M1.82072 101.66C-0.7799 117.423 20.2746 134.078 48.8571 138.794C77.4396 143.51 102.755 134.342 105.329 118.741C107.903 103.137 86.8673 86.3683 58.2848 81.6525C29.7023 76.9368 4.39471 86.0593 1.82072 101.66Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.07"
          d="M3.02369 101.94C0.435685 117.626 21.38 134.229 49.8184 138.921C78.2596 143.613 103.463 134.38 106.012 118.935C108.56 103.49 87.6443 86.7146 59.2059 82.0226C30.7647 77.3301 5.572 86.4949 3.02369 101.94Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.1"
          d="M4.22783 102.223C1.65244 117.833 22.4865 134.382 50.7836 139.051C79.0808 143.719 104.179 134.423 106.702 119.133C109.224 103.843 88.4281 87.0648 60.131 82.3961C31.8339 77.7273 6.75045 86.9335 4.22783 102.223Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.12"
          d="M5.43472 102.504C2.87193 118.037 23.5957 134.533 51.7488 139.178C79.9046 143.824 104.892 134.462 107.389 119.328C109.886 104.194 89.2085 87.4148 61.056 82.7671C32.9001 78.1217 7.93211 87.3672 5.43472 102.504Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.15"
          d="M6.63544 102.786C4.08527 118.243 24.6988 134.686 52.7106 139.307C80.7224 143.929 105.604 134.503 108.075 119.525C110.546 104.547 89.9889 87.7641 61.9772 83.1425C33.9654 78.5209 9.10668 87.8077 6.63497 102.789L6.63544 102.786Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.17"
          d="M7.84527 103.068C5.3077 118.448 25.811 134.838 53.6787 139.436C81.5463 144.034 106.32 134.544 108.765 119.721C111.211 104.899 90.7727 88.1123 62.9051 83.5145C35.0346 78.9162 10.2908 88.2452 7.84527 103.068Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.2"
          d="M9.04256 103.35C6.51761 118.653 26.9107 134.99 54.6371 139.565C82.3635 144.139 107.028 134.585 109.448 119.918C111.868 105.251 91.5497 88.4615 63.8233 83.887C36.0969 79.3124 11.4624 88.6828 9.04256 103.35Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.22"
          d="M10.2535 103.631C7.74113 118.858 28.024 135.142 55.6063 139.693C83.1885 144.244 107.745 134.625 110.142 120.114C112.536 105.603 92.3374 88.8097 64.7551 84.259C37.1729 79.7082 12.6476 89.1198 10.2535 103.631Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.24"
          d="M11.4536 103.912C8.95342 119.066 29.1265 135.294 56.5675 139.822C84.0085 144.349 108.457 134.666 110.825 120.31C113.194 105.955 93.1139 89.1608 65.6734 84.6305C38.2324 80.103 13.8221 89.5569 11.4536 103.912Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.27"
          d="M12.6577 104.193C10.1702 119.271 30.233 135.445 57.5327 139.95C84.8297 144.453 109.172 134.706 111.515 120.506C113.858 106.307 93.8978 89.509 66.5985 85.002C39.3016 80.4983 15.0005 89.9935 12.6577 104.193Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.29"
          d="M13.8641 104.476C11.3892 119.477 31.3417 135.599 58.4974 140.079C85.653 144.56 109.884 134.748 112.202 120.704C114.519 106.66 94.6781 89.8583 67.5225 85.3779C40.3668 80.8975 16.1808 90.4349 13.8641 104.476Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.32"
          d="M15.0693 104.757C12.6069 119.681 32.4493 135.75 59.4636 140.207C86.4752 144.664 110.601 134.788 112.892 120.9C115.184 107.011 95.4629 90.2065 68.4486 85.7494C41.437 81.2928 17.3602 90.8715 15.0693 104.757Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.34"
          d="M16.2713 105.037C13.8215 119.885 33.5536 135.901 60.4239 140.334C87.2942 144.767 111.309 134.826 113.575 121.094C115.84 107.364 96.2389 90.5528 69.3686 86.1195C42.4984 81.6862 18.5365 91.3071 16.2713 105.037Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.37"
          d="M17.4803 105.32C15.0432 120.091 34.6655 136.051 61.394 140.464C88.1202 144.873 112.029 134.869 114.269 121.292C116.509 107.718 97.0276 90.9029 70.2986 86.493C43.5724 82.0834 19.7199 91.7456 17.4803 105.32Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.39"
          d="M18.6823 105.6C16.2578 120.295 35.7699 136.201 62.3543 140.59C88.9392 144.977 112.738 134.904 114.951 121.486C117.165 108.067 97.8031 91.252 71.2187 86.863C44.6338 82.4768 20.8962 92.1812 18.6823 105.6Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.41"
          d="M19.8908 105.884C17.4789 120.502 36.8808 136.356 63.3239 140.722C89.7647 145.084 113.458 134.948 115.646 121.685C117.834 108.422 98.5913 91.6033 72.1477 87.2404C45.7069 82.8779 22.079 92.6208 19.8904 105.886L19.8908 105.884Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.44"
          d="M21.0899 106.162C18.6906 120.705 37.9822 136.505 64.2813 140.847C90.5808 145.186 114.162 134.985 116.325 121.878C118.487 108.771 99.3644 91.9486 73.0649 87.6094C46.7654 83.2703 23.2524 93.0554 21.0899 106.162Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.46"
          d="M22.2936 106.446C19.9069 120.912 39.0883 136.659 65.2465 140.975C91.4019 145.291 114.878 135.025 117.015 122.074C119.152 109.123 100.148 92.2968 73.99 87.981C47.8345 83.6656 24.4309 93.492 22.2941 106.443L22.2936 106.446Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.49"
          d="M23.4965 106.726C21.1225 121.115 40.1964 136.81 66.2077 141.102C92.2219 145.394 115.587 135.064 117.698 122.268C119.809 109.473 100.922 92.6426 74.911 88.351C48.8969 84.0589 25.6081 93.9276 23.497 106.723L23.4965 106.726Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.51"
          d="M24.7007 107.009C22.3388 121.325 41.303 136.964 67.173 141.232C93.0431 145.5 116.302 135.106 118.388 122.466C120.473 109.826 101.706 92.9956 75.8361 88.7245C49.9661 84.4562 26.7866 94.3661 24.7012 107.006L24.7007 107.009Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.54"
          d="M25.9081 107.289C23.5587 121.528 42.4127 137.114 68.1386 141.358C93.8674 145.603 117.016 135.145 119.075 122.663C121.135 110.179 102.487 93.3448 76.7611 89.0974C51.0323 84.8525 27.9678 94.8046 25.9081 107.289Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.56"
          d="M27.1156 107.573C24.7789 121.736 43.5226 137.268 69.1073 141.49C94.692 145.711 117.735 135.188 119.768 122.862C121.802 110.534 103.274 93.696 77.6891 89.4748C52.1044 85.2536 29.1492 95.247 27.1156 107.573Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.59"
          d="M28.3147 107.852C25.9906 121.938 44.624 137.418 70.0646 141.615C95.508 145.813 118.439 135.225 120.447 123.055C122.455 110.885 104.047 94.0413 78.6063 89.8439C53.1629 85.646 30.3226 95.6816 28.3147 107.852Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.61"
          d="M29.5149 108.134C27.2034 122.145 45.7267 137.571 71.026 141.745C96.3253 145.919 119.151 135.268 121.133 123.253C123.116 111.239 104.827 94.3915 79.5275 90.2174C54.2282 86.0433 31.4972 96.1202 29.5149 108.134Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.63"
          d="M30.7257 108.416C28.4268 122.35 46.8398 137.723 71.995 141.874C97.1531 146.025 119.868 135.308 121.824 123.449C123.781 111.591 105.612 94.7397 80.4564 90.5893C55.2983 86.4385 32.6822 96.5577 30.7257 108.416Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.66"
          d="M31.9299 108.698C29.6436 122.555 47.9464 137.876 72.9603 142.003C97.9742 146.13 120.583 135.349 122.514 123.646C124.445 111.944 106.395 95.0917 81.3815 90.9618C56.3675 86.8348 33.8607 96.9953 31.9299 108.698Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.68"
          d="M33.1305 108.979C30.8568 122.759 49.0493 138.027 73.9192 142.13C98.7918 146.234 121.293 135.389 123.198 123.842C125.103 112.294 107.172 95.439 82.3025 91.3358C57.4299 87.2321 35.0357 97.4315 33.13 108.981L33.1305 108.979Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.71"
          d="M34.3375 109.262C32.0764 122.966 50.1587 138.181 74.8872 142.26C99.6158 146.34 122.008 135.431 123.888 124.04C125.767 112.648 107.956 95.7892 83.2276 91.7093C58.4991 87.6293 36.2169 97.8705 34.3375 109.262Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.73"
          d="M35.5416 109.542C33.2932 123.17 51.2652 138.331 75.8525 142.388C100.44 146.444 122.724 135.471 124.578 124.235C126.431 112.999 108.74 96.1364 84.1527 92.0798C59.5654 88.0232 37.3954 98.3061 35.5416 109.542Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.76"
          d="M36.7446 109.825C34.5088 123.376 52.3706 138.484 76.8138 142.517C101.257 146.55 123.433 135.512 125.261 124.432C127.089 113.352 109.517 96.4856 85.0738 92.4528C60.6306 88.4199 38.5727 98.7446 36.7446 109.825Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.78"
          d="M37.9488 110.105C35.7255 123.58 53.4771 138.635 77.779 142.644C102.081 146.654 124.148 135.551 125.951 124.627C127.753 113.702 110.3 96.8357 85.9989 92.8233C61.697 88.8138 39.7512 99.1802 37.9488 110.105Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.8"
          d="M39.1551 110.388C36.9445 123.786 54.5863 138.785 78.7436 142.774C102.901 146.76 124.86 135.593 126.637 124.824C128.414 114.055 111.081 97.185 86.9229 93.1992C62.7651 89.2134 40.9314 99.6216 39.1547 110.39L39.1551 110.388Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.83"
          d="M40.3602 110.668C38.1618 123.993 55.6938 138.937 79.7099 142.902C103.724 146.864 125.577 135.633 127.328 125.02C129.079 114.407 111.865 97.5332 87.8489 93.5707C63.8352 89.6087 42.1108 100.058 40.3598 110.671L40.3602 110.668Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.85"
          d="M41.5623 110.95C39.3764 124.199 56.7982 139.089 80.6701 143.03C104.543 146.969 126.285 135.673 128.01 125.216C129.735 114.759 112.641 97.8814 88.769 93.9427C64.8966 90.004 43.2871 100.496 41.5623 110.95Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.88"
          d="M42.7674 111.231C40.5941 124.403 57.9057 139.24 81.6364 143.158C105.365 147.073 127.001 135.714 128.701 125.412C130.401 115.11 113.426 98.2296 89.6951 94.3143C65.9668 90.3993 44.4666 100.932 42.7674 111.231Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.9"
          d="M43.9728 111.515C41.8122 124.611 59.0135 139.394 82.6005 143.286C106.188 147.178 127.713 135.753 129.387 125.607C131.061 115.461 114.206 98.5769 90.6191 94.6853C67.0321 90.7937 45.6468 101.369 43.9733 111.512L43.9728 111.515Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.93"
          d="M45.178 111.795C43.0299 124.814 60.121 139.545 83.5668 143.413C107.01 147.281 128.43 135.792 130.078 125.802C131.726 115.812 114.991 98.9269 91.5452 95.0558C68.1022 91.188 46.8262 101.805 45.1784 111.792L45.178 111.795Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.95"
          d="M46.3765 112.077C44.2411 125.019 61.2219 139.697 84.5236 143.542C107.825 147.386 129.134 135.833 130.757 125.998C132.379 116.164 115.763 99.2752 92.4614 95.4307C69.1597 91.5862 47.9986 102.245 46.3765 112.077Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          opacity="0.98"
          d="M47.5856 112.358C45.4628 125.224 62.3333 139.849 85.4937 143.67C108.651 147.49 129.855 135.87 131.451 126.194C133.048 116.518 116.552 99.6235 93.3913 95.8023C70.2337 91.9815 49.1825 102.679 47.586 112.355L47.5856 112.358Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
        <path
          d="M48.788 112.638C46.6778 125.427 63.4381 139.999 86.4545 143.796C109.471 147.594 130.563 135.909 132.133 126.391C133.704 116.874 117.328 99.9727 94.3114 96.1752C71.2951 92.3778 50.3587 103.117 48.788 112.638Z"
          fill="#071D33"
          fillOpacity="0.11"
        />
      </g>
      <path
        d="M50.0384 108.686C48.6926 121.311 61.7333 129.278 72.021 133.613C81.5744 137.632 92.0307 139.485 102.382 139.123C115.114 138.865 131.904 132.78 133.887 120.161L133.611 126.025C131.744 138.061 115.593 143.934 103.184 144.521C93.6831 145.108 84.0613 143.739 75.0736 140.619C64.9865 137.038 53.2703 130.243 49.6206 119.574C49.0174 117.689 48.7304 115.699 48.8596 113.72C48.8249 113.156 50.498 108.011 50.624 107.142C50.5978 107.301 50.0566 108.523 50.0361 108.682L50.0384 108.686Z"
        fill="#051A2F"
        fillOpacity="0.12"
      />
      <path
        d="M142.977 91.7117C165.371 104.666 165.49 125.664 143.241 138.618C120.995 151.572 84.8048 151.572 62.4143 138.618C40.0201 125.672 39.9017 104.67 62.1508 91.7156C84.3999 78.7615 120.587 78.7615 142.977 91.7156V91.7117ZM67.2729 135.794C86.9323 147.164 118.814 147.167 138.348 135.794C157.877 124.42 157.774 105.917 138.115 94.5475C118.455 83.1777 86.5694 83.1739 67.0361 94.5475C47.5027 105.921 47.6134 124.424 67.269 135.798"
        fill="url(#paint1_linear_6823_8200)"
      />
      <path
        d="M141.428 92.2154C162.757 104.503 162.87 124.496 141.681 136.783C120.488 149.074 85.8986 149.07 64.5735 136.783C43.2444 124.5 43.1238 104.507 64.3166 92.2154C85.5055 79.9282 120.103 79.9282 141.428 92.2154Z"
        fill="url(#paint2_linear_6823_8200)"
      />
      <path
        d="M108.534 120.588C108.974 116.315 105.989 112.446 101.744 111.788L64.3727 105.999C58.1184 105.03 52.8332 110.628 54.1598 116.817C54.98 120.643 58.1713 123.506 62.064 123.907L99.6812 127.785C104.113 128.242 108.077 125.02 108.534 120.588Z"
        fill="url(#paint3_linear_6823_8200)"
        fillOpacity="0.48"
      />
      <path
        d="M176.183 0.819473C180.912 0.111246 191.335 6.41136 195.121 13.1755C196.415 15.487 195.56 18.2256 193.924 20.3095L113.32 123.03C112.969 123.477 112.582 123.892 112.161 124.273L111.426 124.938C107.57 128.426 101.684 128.377 97.8864 124.825L58.5639 88.0423C54.1932 83.9539 54.3682 76.9677 58.9382 73.1034L69.341 64.3066C73.0512 61.1693 78.4795 61.1529 82.2086 64.2677L101.913 80.7258C102.335 81.0782 102.962 81.0239 103.317 80.6042L154.149 20.5344C154.149 20.5344 170.909 1.60925 176.183 0.819473Z"
        fill="url(#paint4_linear_6823_8200)"
      />
      <path
        d="M177.417 9.62463C183.072 4.32668 193.298 10.8582 194.646 16.3745C194.935 17.5566 194.333 18.7099 193.561 19.6509L111.509 119.729C108.916 122.891 104.177 123.167 101.235 120.328L66.9989 87.2902C63.8681 84.2689 64.2228 79.1536 67.7407 76.5933L77.8131 69.2628C80.4731 67.327 84.1222 67.5046 86.5815 69.6897L107.72 88.4709C108.577 89.2319 109.896 89.1198 110.612 88.2255C139.581 52.0452 170.553 16.0557 177.417 9.62463Z"
        fill="url(#paint5_linear_6823_8200)"
      />
      <path
        d="M70.9311 91.1144L108.004 126.196C108.424 126.593 109.092 126.553 109.461 126.108L193.543 24.7069C196.134 21.5822 195.533 16.916 192.234 14.5504L187.318 11.0246C184.317 8.87272 180.161 9.42163 177.822 12.2787L111.216 93.6362C110.487 94.5267 109.159 94.6197 108.313 93.8394L87.9759 75.0815C85.4631 72.7638 81.6439 72.6001 78.9419 74.6941L71.4544 80.4971C68.0611 83.1269 67.8129 88.1636 70.9311 91.1144Z"
        fill="url(#paint6_linear_6823_8200)"
        stroke="#4F4795"
        strokeWidth="0.5"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6823_8200"
          x1="45.057"
          y1="121.408"
          x2="159.764"
          y2="122.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#253C5A" />
          <stop offset="0.05" stopColor="#314A69" />
          <stop offset="0.18" stopColor="#38587A" />
          <stop offset="0.29" stopColor="#3A5E81" />
          <stop offset="0.776796" stopColor="#4A7CAE" />
          <stop offset="1" stopColor="#2C4462" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6823_8200"
          x1="45.5226"
          y1="115.202"
          x2="159.708"
          y2="115.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#112845" />
          <stop offset="1" stopColor="#38629C" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6823_8200"
          x1="157.5"
          y1="121.5"
          x2="48.4759"
          y2="114.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B77B2" />
          <stop offset="1" stopColor="#264C82" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6823_8200"
          x1="108.298"
          y1="122.874"
          x2="56.1272"
          y2="117.495"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6823_8200"
          x1="169.224"
          y1="-7.29863"
          x2="75.5397"
          y2="106.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#163259" />
          <stop offset="0.05" stopColor="#3164A2" />
          <stop offset="0.272918" stopColor="#3971B3" />
          <stop offset="0.48906" stopColor="#2A579E" />
          <stop offset="0.731253" stopColor="#123155" />
          <stop offset="0.797878" stopColor="#24548E" />
          <stop offset="0.934262" stopColor="#244E86" />
          <stop offset="1" stopColor="#163258" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6823_8200"
          x1="83.9999"
          y1="105"
          x2="192.5"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#30699D" />
          <stop offset="1" stopColor="#619DD3" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6823_8200"
          x1="189.625"
          y1="21.4309"
          x2="105.522"
          y2="151.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4ADECD" />
          <stop offset="1" stopColor="#6077E2" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CheckmarkGraphic;
